import { logger } from "@/utils/logger";
import { useCallback } from 'react';
import { useFormSubmissionService } from '../services/FormSubmissionService';
import { useOptimizedFormSubmission } from './useOptimizedFormSubmission';

// Simplified hook that delegates to the service and also handles debug modal
export const useFormSubmission = (
  sendMessage: (message: string, formData?: any) => Promise<void>,
  trackLead?: (leadId: string, formType?: string) => void
) => {
  const { handleFormSubmit } = useFormSubmissionService(sendMessage);
  const { processFormEmails } = useOptimizedFormSubmission();

  return {
    handleFormSubmit: useCallback(async (submittedFormData: { [key: string]: string }) => {
      // Process form emails for debug modal
      await processFormEmails();
      
      // Handle the main form submission (returns lead ID from DB if available)
      const leadId = await handleFormSubmit(submittedFormData);
      
      // Track lead for Shift Digital - fire with real lead ID from database
      if (trackLead && leadId) {
        const formType = submittedFormData.formType || submittedFormData.formtype || 'form';
        trackLead(leadId, formType);
        logger.log('🔵 [SHIFT] chatLead fired on form submission with real DB leadId:', leadId, 'formType:', formType);
      }
    }, [handleFormSubmit, processFormEmails, trackLead])
  };
};